/** Miss Generation branding assets — competitions 14 and 24 only. */

export const MISS_GENERATION_COMPETITION_IDS = [14, 24];

export const MISS_GENERATION_DETAIL_SECTION_BG =
  "/assets/competition-themes/miss-generation-detail-section-bg.jpg";

export const MISS_GENERATION_PODIUM_BG =
  "/assets/competition-themes/miss-generation-podium-bg.jpg";

/** Detail hero + videos (damask on white). */
export const MISS_GENERATION_BACKGROUND_OPACITY = 0.1;

/** Hall of Fame–style panel (detail hero only). */
export const MISS_GENERATION_DETAIL_SURFACE = "#f5f5f5";

/** Damask / portrait framing on detail hero. */
export const MISS_GENERATION_DETAIL_BG_POSITION = "28% center";

/** Casting-call banner on dark podium. */
export const MISS_GENERATION_PODIUM_BG_POSITION = "50% 42%";

/** Flat stage under casting-call watermark (no scrim gradients). */
export const MISS_GENERATION_PODIUM_SURFACE = "#14161f";

export function isMissGenerationCompetition(competitionId) {
  return MISS_GENERATION_COMPETITION_IDS.includes(Number(competitionId));
}
